<template>
  <div v-if="visible" class="login-timeout-overlay">
    <div class="login-timeout-dialog">
      <div class="dialog-header">
        <i class="el-icon-warning-outline"></i>
        <h3>{{ $t('errors.loginTimeout') }}</h3>
      </div>
      <div class="dialog-content">
        <p>{{ message }}</p>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginTimeoutDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: function() {
        return this.$t ? this.$t('errors.loginExpired') : '您的登录已过期，请重新登录'
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.login-timeout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.login-timeout-dialog {
  background: white;
  border-radius: 8px;
  padding: 24px;
  min-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: dialog-fade-in 0.3s ease-out;
}

@keyframes dialog-fade-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dialog-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.dialog-header i {
  font-size: 24px;
  color: #f56c6c;
  margin-right: 12px;
}

.dialog-header h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
  font-weight: 500;
}

.dialog-content {
  margin-bottom: 24px;
}

.dialog-content p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  min-width: 80px;
}

.dialog-footer .el-button--primary {
  background: var(--linear-2-paints, linear-gradient(90deg, #7eb4eb, #b16ef9));
  border: none;
}

.dialog-footer .el-button--primary:hover {
  background: var(--linear-2-paints, linear-gradient(90deg, #6ba3e8, #a05df7));
}
</style>
